unit Unit1;

interface

uses
  SysUtils, Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  WEBLib.Controls, WEBLib.StdCtrls, WEBLib.Grids,  WEBLib.ExtCtrls, WEBLib.CDS, WEBLib.Buttons;
type
  TForm1 = class(TForm)
    N: TLabel;
    WebImageControl1: TImageControl;
    WebComboBox1: TComboBox;
    WebComboBox2: TComboBox;
    WebComboBox3: TComboBox;
    WebComboBox4: TComboBox;
    WebLabel4: TLabel;
    WebLabel5: TLabel;
    WebLabel6: TLabel;
    WebLabel7: TLabel;
    WebLabel8: TLabel;
    WebComboBox5: TComboBox;
    WebLabel9: TLabel;
    WebImageControl2: TImageControl;
    WebImageControl3: TImageControl;
    WebImageControl4: TImageControl;
    WebImageControl5: TImageControl;
    WebImageControl6: TImageControl;
    WebEdit1: TEdit;
    WebEdit2: TEdit;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    WebLabel15: TLabel;
    procedure WebComboBox1Change(Sender: TObject);
    procedure WebComboBox4Change(Sender: TObject);
    procedure WebComboBox5Change(Sender: TObject);
    procedure WebComboBox2Change(Sender: TObject);
    procedure WebComboBox3Change(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormDeactivate(Sender: TObject);
  private
    { Private declarations }
  protected
    procedure LoadDFMValues; override;
  public
    { Public declarations }
  end;

var
  Form1: TForm1;

implementation


uses  uFrmMain;

procedure TForm1.WebComboBox1Change(Sender: TObject);
var   DIC               : String;
begin
  case WebComboBox1.ItemIndex of
  0: DIC:='skosny.jpg';
  1: DIC:='plaski.jpg';
  2: DIC:='grunt.jpg';
  end;
  WebImageControl1.URL:='img\'+DIC;
  WebImageControl2.URL:='img\'+DIC;
  if DIC='plaski.jpg' then WebImageControl3.URL:='img\Pusty.jpg';

  if WebComboBox1.ItemIndex=1 then begin
   WebComboBox2.Visible:=False;
  Weblabel5.Visible:=false;
end else
begin
   WebComboBox2.Visible:=True;
  Weblabel5.Visible:=True;
end;
  FrmMain.WebEdit6.Text:=WebEdit1.Text;
  FrmMain.WebEdit20.Text:=WebComboBox3.Text;
  FrmMain.WebEdit8.Text:=WebComboBox4.Text;
  FrmMain.WebEdit9.Text:=WebComboBox5.Text;
  FrmMain.WebEdit14.Text:=WebComboBox1.Text;
  FrmMain.WebEdit15.Text:=WebComboBox2.Text;
  FrmMain.WebEdit20.Text:=WebComboBox3.Text;
end;

procedure TForm1.WebComboBox2Change(Sender: TObject);
var   DIC               : String;
begin
  case WebComboBox2.ItemIndex of
  0: begin DIC:='dachowka.jpg'; WebEdit1.Text:='370'; end;
  1: begin DIC:='blachodachowka.jpg'; WebEdit1.Text:='318'; end;
  2: begin DIC:='blacha trapezowa.jpg'; WebEdit1.Text:='253'; end;
  3: begin DIC:='gont.jpg'; WebEdit1.Text:='290'; end;
  4: begin DIC:='papa.jpg'; WebEdit1.Text:='290'; end;
  5: begin DIC:='rabek.jpg'; WebEdit1.Text:='370'; end;
  6: begin DIC:='karpiowka.jpg'; WebEdit1.Text:='365'; end;
  7: begin DIC:='grunt.jpg'; WebEdit1.Text:='650'; end;
  end;
  WebImageControl1.URL:='img\'+DIC;
  WebImageControl3.URL:='img\'+DIC;
  FrmMain.WebEdit6.Text:=WebEdit1.Text;
  FrmMain.WebEdit20.Text:=WebComboBox3.Text;
  FrmMain.WebEdit8.Text:=WebComboBox4.Text;
  FrmMain.WebEdit9.Text:=WebComboBox5.Text;
  FrmMain.WebEdit14.Text:=WebComboBox1.Text;
  FrmMain.WebEdit15.Text:=WebComboBox2.Text;
  FrmMain.WebEdit20.Text:=WebComboBox3.Text;
end;

procedure TForm1.WebComboBox3Change(Sender: TObject);
var   DIC               : String;
begin
  case WebComboBox3.ItemIndex of
  0: DIC:='15.jpg';
  1: DIC:='25.jpg';
  2: DIC:='35.jpg';
  3: DIC:='40.jpg';
  end;
  WebImageControl1.URL:='img\'+DIC;
  WebImageControl4.URL:='img\'+DIC;
  FrmMain.WebEdit6.Text:=WebEdit1.Text;
  FrmMain.WebEdit20.Text:=WebComboBox3.Text;
  FrmMain.WebEdit8.Text:=WebComboBox4.Text;
  FrmMain.WebEdit9.Text:=WebComboBox5.Text;
  FrmMain.WebEdit14.Text:=WebComboBox1.Text;
  FrmMain.WebEdit15.Text:=WebComboBox2.Text;
  FrmMain.WebEdit20.Text:=WebComboBox3.Text;
end;

procedure TForm1.WebComboBox4Change(Sender: TObject);
var   DIC               : String;
begin
  case WebComboBox4.ItemIndex of
  0: DIC:='komS.jpg';
  1: DIC:='komW.jpg';
  2: DIC:='komZ.jpg';
  3: DIC:='komN.jpg';
  end;
  WebImageControl1.URL:='img\'+DIC;
  WebImageControl5.URL:='img\'+DIC;
  FrmMain.WebEdit6.Text:=WebEdit1.Text;
  FrmMain.WebEdit20.Text:=WebComboBox3.Text;
  FrmMain.WebEdit8.Text:=WebComboBox4.Text;
  FrmMain.WebEdit9.Text:=WebComboBox5.Text;
  FrmMain.WebEdit14.Text:=WebComboBox1.Text;
  FrmMain.WebEdit15.Text:=WebComboBox2.Text;
  FrmMain.WebEdit20.Text:=WebComboBox3.Text;
end;

procedure TForm1.WebComboBox5Change(Sender: TObject);
var   DIC               : String;
begin
  case WebComboBox5.ItemIndex of
  0: DIC:='pion.jpg';
  1: DIC:='poziom.jpg';
  end;
  WebImageControl1.URL:='img\'+DIC;
  WebImageControl6.URL:='img\'+DIC;
  FrmMain.WebEdit6.Text:=WebEdit1.Text;
  FrmMain.WebEdit20.Text:=WebComboBox3.Text;
  FrmMain.WebEdit8.Text:=WebComboBox4.Text;
  FrmMain.WebEdit9.Text:=WebComboBox5.Text;
  FrmMain.WebEdit14.Text:=WebComboBox1.Text;
  FrmMain.WebEdit15.Text:=WebComboBox2.Text;
  FrmMain.WebEdit20.Text:=WebComboBox3.Text;
end;

procedure TForm1.WebFormCreate(Sender: TObject);
var   DIC               : String;
begin
  DIC:='skosny.jpg';
  WebComboBox1.ItemIndex:=0;
  WebImageControl1.URL:='img\'+DIC;

  DIC:='skosny.jpg';
  WebComboBox1.ItemIndex:=0;
  WebImageControl2.URL:='img\'+DIC;

  DIC:='dachowka.jpg';
  WebComboBox2.ItemIndex:=0;
  WebImageControl3.URL:='img\'+DIC;

  DIC:='35.jpg';
  WebComboBox3.ItemIndex:=2;
  WebImageControl4.URL:='img\'+DIC;

  DIC:='komS.jpg';
  WebComboBox4.ItemIndex:=0;
  WebImageControl5.URL:='img\'+DIC;

  DIC:='pion.jpg';
  WebComboBox5.ItemIndex:=0;
  WebImageControl6.URL:='img\'+DIC;
  FrmMain.WebEdit6.Text:=WebEdit1.Text;
  FrmMain.WebEdit20.Text:=WebComboBox3.Text;
  FrmMain.WebEdit8.Text:=WebComboBox4.Text;
  FrmMain.WebEdit9.Text:=WebComboBox5.Text;
  FrmMain.WebEdit14.Text:=WebComboBox1.Text;
  FrmMain.WebEdit15.Text:=WebComboBox2.Text;
  FrmMain.WebEdit20.Text:=WebComboBox3.Text;
end;

procedure TForm1.WebFormDeactivate(Sender: TObject);
begin
  FrmMain.WebEdit6.Text:=WebEdit1.Text;
  FrmMain.WebEdit20.Text:=WebComboBox3.Text;
  FrmMain.WebEdit8.Text:=WebComboBox4.Text;
  FrmMain.WebEdit9.Text:=WebComboBox5.Text;
  FrmMain.WebEdit14.Text:=WebComboBox1.Text;
  FrmMain.WebEdit15.Text:=WebComboBox2.Text;
  FrmMain.WebEdit20.Text:=WebComboBox3.Text;
end;

procedure TForm1.LoadDFMValues;
begin
  inherited LoadDFMValues;

  N := TLabel.Create(Self);
  WebImageControl1 := TImageControl.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  WebImageControl2 := TImageControl.Create(Self);
  WebImageControl3 := TImageControl.Create(Self);
  WebImageControl4 := TImageControl.Create(Self);
  WebImageControl5 := TImageControl.Create(Self);
  WebImageControl6 := TImageControl.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel15 := TLabel.Create(Self);
  WebComboBox1 := TComboBox.Create(Self);
  WebComboBox2 := TComboBox.Create(Self);
  WebComboBox3 := TComboBox.Create(Self);
  WebComboBox4 := TComboBox.Create(Self);
  WebComboBox5 := TComboBox.Create(Self);
  WebEdit1 := TEdit.Create(Self);
  WebEdit2 := TEdit.Create(Self);

  N.BeforeLoadDFMValues;
  WebImageControl1.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebImageControl2.BeforeLoadDFMValues;
  WebImageControl3.BeforeLoadDFMValues;
  WebImageControl4.BeforeLoadDFMValues;
  WebImageControl5.BeforeLoadDFMValues;
  WebImageControl6.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel15.BeforeLoadDFMValues;
  WebComboBox1.BeforeLoadDFMValues;
  WebComboBox2.BeforeLoadDFMValues;
  WebComboBox3.BeforeLoadDFMValues;
  WebComboBox4.BeforeLoadDFMValues;
  WebComboBox5.BeforeLoadDFMValues;
  WebEdit1.BeforeLoadDFMValues;
  WebEdit2.BeforeLoadDFMValues;
  try
    Name := 'Form1';
    Left := 0;
    Top := 0;
    Width := 640;
    Height := 450;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, Self, 'OnDeactivate', 'WebFormDeactivate');
    N.SetParentComponent(Self);
    N.Name := 'N';
    N.Left := 11;
    N.Top := 82;
    N.Width := 169;
    N.Height := 16;
    N.Caption := 'Opis obiektu budowlanego';
    N.Font.Charset := DEFAULT_CHARSET;
    N.Font.Color := clMenuHighlight;
    N.Font.Height := 16;
    N.Font.Name := 'Tahoma';
    N.Font.Style := [fsBold];
    N.ParentFont := False;
    WebImageControl1.SetParentComponent(Self);
    WebImageControl1.Name := 'WebImageControl1';
    WebImageControl1.Left := 11;
    WebImageControl1.Top := 104;
    WebImageControl1.Width := 361;
    WebImageControl1.Height := 292;
    WebImageControl1.ChildOrder := 1;
    WebLabel4.SetParentComponent(Self);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 388;
    WebLabel4.Top := 84;
    WebLabel4.Width := 101;
    WebLabel4.Height := 13;
    WebLabel4.Caption := 'Rodzaj dachu/gruntu';
    WebLabel5.SetParentComponent(Self);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 388;
    WebLabel5.Top := 151;
    WebLabel5.Width := 108;
    WebLabel5.Height := 13;
    WebLabel5.Caption := 'Rodzaj pokrycia dachu';
    WebLabel6.SetParentComponent(Self);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 388;
    WebLabel6.Top := 227;
    WebLabel6.Width := 96;
    WebLabel6.Height := 13;
    WebLabel6.Caption := 'Nachylenie instalacji';
    WebLabel7.SetParentComponent(Self);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 388;
    WebLabel7.Top := 297;
    WebLabel7.Width := 94;
    WebLabel7.Height := 13;
    WebLabel7.Caption := 'Orientacja instalacji';
    WebLabel8.SetParentComponent(Self);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 445;
    WebLabel8.Top := 249;
    WebLabel8.Width := 29;
    WebLabel8.Height := 13;
    WebLabel8.Caption := 'stopni';
    WebLabel9.SetParentComponent(Self);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 388;
    WebLabel9.Top := 375;
    WebLabel9.Width := 92;
    WebLabel9.Height := 13;
    WebLabel9.Caption := 'Po'#322'o'#380'enie modu'#322#243'w';
    WebImageControl2.SetParentComponent(Self);
    WebImageControl2.Name := 'WebImageControl2';
    WebImageControl2.Left := 549;
    WebImageControl2.Top := 78;
    WebImageControl2.Width := 65;
    WebImageControl2.Height := 59;
    WebImageControl2.ChildOrder := 18;
    WebImageControl3.SetParentComponent(Self);
    WebImageControl3.Name := 'WebImageControl3';
    WebImageControl3.Left := 549;
    WebImageControl3.Top := 151;
    WebImageControl3.Width := 65;
    WebImageControl3.Height := 58;
    WebImageControl3.ChildOrder := 19;
    WebImageControl4.SetParentComponent(Self);
    WebImageControl4.Name := 'WebImageControl4';
    WebImageControl4.Left := 549;
    WebImageControl4.Top := 227;
    WebImageControl4.Width := 65;
    WebImageControl4.Height := 57;
    WebImageControl4.ChildOrder := 20;
    WebImageControl5.SetParentComponent(Self);
    WebImageControl5.Name := 'WebImageControl5';
    WebImageControl5.Left := 549;
    WebImageControl5.Top := 297;
    WebImageControl5.Width := 65;
    WebImageControl5.Height := 64;
    WebImageControl5.ChildOrder := 21;
    WebImageControl6.SetParentComponent(Self);
    WebImageControl6.Name := 'WebImageControl6';
    WebImageControl6.Left := 549;
    WebImageControl6.Top := 374;
    WebImageControl6.Width := 65;
    WebImageControl6.Height := 64;
    WebImageControl6.ChildOrder := 22;
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 63;
    WebLabel1.Top := 405;
    WebLabel1.Width := 59;
    WebLabel1.Height := 13;
    WebLabel1.Caption := 'Koszt 1 kWp';
    WebLabel1.Visible := False;
    WebLabel2.SetParentComponent(Self);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 261;
    WebLabel2.Top := 402;
    WebLabel2.Width := 30;
    WebLabel2.Height := 13;
    WebLabel2.Caption := 'Strata';
    WebLabel2.Visible := False;
    WebLabel15.SetParentComponent(Self);
    WebLabel15.Name := 'WebLabel15';
    WebLabel15.Left := 11;
    WebLabel15.Top := 428;
    WebLabel15.Width := 211;
    WebLabel15.Height := 13;
    WebLabel15.Caption := 'Kalkulator fotowoltaiczny - Pro-Sun (c) 2020';
    WebLabel15.Color := clYellow;
    WebLabel15.Transparent := False;
    WebComboBox1.SetParentComponent(Self);
    WebComboBox1.Name := 'WebComboBox1';
    WebComboBox1.Left := 388;
    WebComboBox1.Top := 103;
    WebComboBox1.Width := 145;
    WebComboBox1.Height := 22;
    WebComboBox1.Color := clInfoBk;
    WebComboBox1.Text := 'Sko'#347'ny';
    SetEvent(WebComboBox1, Self, 'OnChange', 'WebComboBox1Change');
    WebComboBox1.ItemIndex := 0;
    WebComboBox1.Items.BeginUpdate;
    try
      WebComboBox1.Items.Clear;
      WebComboBox1.Items.Add('Sko'#347'ny');
      WebComboBox1.Items.Add('P'#322'aski');
      WebComboBox1.Items.Add('Grunt');
    finally
      WebComboBox1.Items.EndUpdate;
    end;
    WebComboBox2.SetParentComponent(Self);
    WebComboBox2.Name := 'WebComboBox2';
    WebComboBox2.Left := 388;
    WebComboBox2.Top := 168;
    WebComboBox2.Width := 145;
    WebComboBox2.Height := 22;
    WebComboBox2.Color := clInfoBk;
    WebComboBox2.Text := 'Dach'#243'wka';
    SetEvent(WebComboBox2, Self, 'OnChange', 'WebComboBox2Change');
    WebComboBox2.ItemIndex := 0;
    WebComboBox2.Items.BeginUpdate;
    try
      WebComboBox2.Items.Clear;
      WebComboBox2.Items.Add('Dach'#243'wka');
      WebComboBox2.Items.Add('Blachodach'#243'wka');
      WebComboBox2.Items.Add('Blacha trapezowa');
      WebComboBox2.Items.Add('Gont');
      WebComboBox2.Items.Add('Papa');
      WebComboBox2.Items.Add('R'#261'bek');
      WebComboBox2.Items.Add('Karpi'#243'wka');
      WebComboBox2.Items.Add('Grunt');
    finally
      WebComboBox2.Items.EndUpdate;
    end;
    WebComboBox3.SetParentComponent(Self);
    WebComboBox3.Name := 'WebComboBox3';
    WebComboBox3.Left := 388;
    WebComboBox3.Top := 246;
    WebComboBox3.Width := 49;
    WebComboBox3.Height := 22;
    WebComboBox3.Color := clInfoBk;
    WebComboBox3.Text := '35';
    SetEvent(WebComboBox3, Self, 'OnChange', 'WebComboBox3Change');
    WebComboBox3.ItemIndex := 2;
    WebComboBox3.Items.BeginUpdate;
    try
      WebComboBox3.Items.Clear;
      WebComboBox3.Items.Add('15');
      WebComboBox3.Items.Add('25');
      WebComboBox3.Items.Add('35');
      WebComboBox3.Items.Add('40');
    finally
      WebComboBox3.Items.EndUpdate;
    end;
    WebComboBox4.SetParentComponent(Self);
    WebComboBox4.Name := 'WebComboBox4';
    WebComboBox4.Left := 388;
    WebComboBox4.Top := 315;
    WebComboBox4.Width := 145;
    WebComboBox4.Height := 22;
    WebComboBox4.Color := clInfoBk;
    WebComboBox4.Text := 'Po'#322'udnie';
    SetEvent(WebComboBox4, Self, 'OnChange', 'WebComboBox4Change');
    WebComboBox4.ItemIndex := 0;
    WebComboBox4.Items.BeginUpdate;
    try
      WebComboBox4.Items.Clear;
      WebComboBox4.Items.Add('Po'#322'udnie');
      WebComboBox4.Items.Add('Zach'#243'd');
      WebComboBox4.Items.Add('Wsch'#243'd');
      WebComboBox4.Items.Add('P'#243#322'noc');
    finally
      WebComboBox4.Items.EndUpdate;
    end;
    WebComboBox5.SetParentComponent(Self);
    WebComboBox5.Name := 'WebComboBox5';
    WebComboBox5.Left := 388;
    WebComboBox5.Top := 393;
    WebComboBox5.Width := 145;
    WebComboBox5.Height := 22;
    WebComboBox5.Color := clInfoBk;
    WebComboBox5.Text := 'Pion';
    SetEvent(WebComboBox5, Self, 'OnChange', 'WebComboBox5Change');
    WebComboBox5.ItemIndex := 0;
    WebComboBox5.Items.BeginUpdate;
    try
      WebComboBox5.Items.Clear;
      WebComboBox5.Items.Add('Pion');
      WebComboBox5.Items.Add('Poziom');
    finally
      WebComboBox5.Items.EndUpdate;
    end;
    WebEdit1.SetParentComponent(Self);
    WebEdit1.Name := 'WebEdit1';
    WebEdit1.Left := 131;
    WebEdit1.Top := 403;
    WebEdit1.Width := 82;
    WebEdit1.Height := 19;
    WebEdit1.ChildOrder := 18;
    WebEdit1.Text := '370';
    WebEdit1.Visible := False;
    WebEdit2.SetParentComponent(Self);
    WebEdit2.Name := 'WebEdit2';
    WebEdit2.Left := 299;
    WebEdit2.Top := 402;
    WebEdit2.Width := 89;
    WebEdit2.Height := 19;
    WebEdit2.ChildOrder := 19;
    WebEdit2.Text := '0';
    WebEdit2.Visible := False;
  finally
    N.AfterLoadDFMValues;
    WebImageControl1.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebImageControl2.AfterLoadDFMValues;
    WebImageControl3.AfterLoadDFMValues;
    WebImageControl4.AfterLoadDFMValues;
    WebImageControl5.AfterLoadDFMValues;
    WebImageControl6.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel15.AfterLoadDFMValues;
    WebComboBox1.AfterLoadDFMValues;
    WebComboBox2.AfterLoadDFMValues;
    WebComboBox3.AfterLoadDFMValues;
    WebComboBox4.AfterLoadDFMValues;
    WebComboBox5.AfterLoadDFMValues;
    WebEdit1.AfterLoadDFMValues;
    WebEdit2.AfterLoadDFMValues;
  end;
end;

end.
